import React, { FC } from "react";
import classNames, { Argument } from "classnames/dedupe";
import { Typography } from "../../Fundamentals/Typography/Typography";
import Price, { TPrice, TPriceVariant } from "./Price";
import { TThemeVariant } from "../../Utility/ThemeProvider/ThemeContext";

export interface IProductPriceProps {
  classes?: {
    root?: Argument;
  };
  /** List of prices. Order is important ! */
  prices: Array<TPrice>;
  /** Current theme */
  theme?: TThemeVariant;
}

export const BASIC_PRICE_VARIANTS: Array<TPriceVariant> = [
  "current",
  "original",
];

export const extractCurrentPrice = (prices: TPrice[]): TPrice =>
  prices.find((p) => !p.variant || p.variant === "current") || prices[0];

export const onlyMainPrices = (prices: TPrice[]): TPrice[] =>
  prices.filter(
    (price) => !price.variant || BASIC_PRICE_VARIANTS.includes(price.variant),
  );

const ProductPrice: FC<IProductPriceProps> = ({ classes, prices, theme }) => {
  const hasDiscountedPrice = !!prices.find(
    (price) => price.variant === "original" && Number(price.price) > 0,
  );
  const hasNonPrimary = !!prices.find(
    (price) => price.variant && price.variant !== "original",
  );

  const hasCustom = !!prices.find(
    (price) => price.variant && !BASIC_PRICE_VARIANTS.includes(price.variant),
  );
  return (
    <Typography
      variant="d-header-14-bold"
      as="div"
      classes={{
        root: classNames(
          "product-price",
          {
            "product-price--in-two-rows": hasCustom && prices.length <= 2,
            "product-price--in-three-rows": prices.length > 2,
          },
          classes?.root,
        ),
      }}
      data-testid="product-price"
    >
      {prices.map((price) => (
        <Price
          key={Math.random().toString(36).substring(7)}
          theme={theme}
          isHighlighted={
            (!price.variant || price.variant === "current") &&
            (hasDiscountedPrice || hasNonPrimary)
          }
          {...price}
        />
      ))}
    </Typography>
  );
};

export default ProductPrice;
